import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useAPI from '../../../api';
import CustomDialog from '../../../Components/Dialog/CustomDialog';
import EditorWrapper from './Shared/EditorWrapper';
import { EDITORS } from '../Utils/constants';
import getErrorMessage from '../../../Helpers/Errors/getErrorMessage';

const TemplateMessageEditor = function TemplateMessageEditor({
  open = null,
  onClose = () => {},
}) {
  const intl = useIntl();
  const API = useAPI();

  const Icon = EDITORS[open];

  const landingPagesCallback = () =>
    API.getAllLandingPages(
      (res) => Promise.resolve(res),
      (err) => {
        throw new Error(getErrorMessage(err));
      }
    );

  const createLandingPage = (LandingPageData) =>
    API.createLandingPage(
      LandingPageData,
      {},
      (res) => Promise.resolve(res),
      (err) => {
        throw new Error(getErrorMessage(err));
      }
    );
  const editLandingPage = (LandingPageData) =>
    API.editLandingPage(
      LandingPageData,
      {},
      (res) => Promise.resolve(res),
      (err) => {
        throw new Error(getErrorMessage(err));
      }
    );

  const createTemplateCallback = (TemplateData) =>
    API.createTemplate(
      { ...TemplateData, messageType: 'GP' },
      {},
      (res) => Promise.resolve(res),
      (err) => {
        throw new Error(getErrorMessage(err));
      }
    );
  const editTemplate = (TemplateData) =>
    API.editTemplate(
      TemplateData,
      {},
      (res) => Promise.resolve(res),
      (err) => {
        throw new Error(getErrorMessage(err));
      }
    );

  const templatesCallback = () =>
    API.getAllTemplates(
      {},
      (res) => Promise.resolve(res),
      (err) => {
        throw new Error(getErrorMessage(err));
      }
    );

  return (
    <CustomDialog
      id="template-editor"
      open={Boolean(open)}
      close={onClose}
      title={intl.messages[open]}
      icon={
        open ? <Icon sx={{ fontSize: 24, color: 'white.main' }} /> : <div />
      }
      fullScreen
      showOnly
      disableActions
      styles={{ content: { padding: 0 } }}
    >
      <EditorWrapper
        editorType={open}
        templatesCallback={
          open === 'LANDING_PAGES' ? landingPagesCallback : templatesCallback
        }
        createCallback={
          open === 'LANDING_PAGES' ? createLandingPage : createTemplateCallback
        }
        editCallback={open === 'LANDING_PAGES' ? editLandingPage : editTemplate}
      />
    </CustomDialog>
  );
};

TemplateMessageEditor.propTypes = {
  open: PropTypes.string,
  onClose: PropTypes.func,
};

export default TemplateMessageEditor;
